<template>
    <div class="detailed_graphs_collapse-container" :class="{open : isOpen}">

        <div @click="isOpen = !isOpen" class="title-container">
            <h2 class="title">{{getDetailedGraphs.title}} <span class="amount">({{Object.keys(getDetailedGraphs.elements).length}})</span>
            </h2>
            <div class="plus_icon"></div>
        </div>

        <div class="elements-container">
            <div v-for="(element, key) in getDetailedGraphs.elements" class="element" @click="loadGraph">
                <h3>{{element.title}}</h3>
                <div class="graph">
                    <img :src="element.graph.url">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DetailedGraphsCollapse",
        data() {
            return {
                isOpen: false
            }
        },
        methods: {
            loadGraph() {

            }
        },
        computed: {

            getDetailedGraphs() {
                return this.$store.state.detailedGraphs;
            }
        },
    }
</script>
